import httpClient from './httpClient';

export function setAxiosAuthHeader(bearerToken) {
    httpClient.defaults.headers.common['Authorization'] = bearerToken
        ? `Bearer ${bearerToken}`
        : "";
}

export function setAxiosDatasetHeader(dataset) {
    httpClient.defaults.headers.common['dataset'] = dataset;
}
